import React from 'react';
interface ChampionLogoProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'dark' | 'light';
  showPartnerLabel?: boolean;
}
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/qx5Lg8aAYGUHHWyYpDu3qx/ChampionLogo_GDI_Primary.png';
export function ChampionLogo({
  size = 'md',
  variant = 'dark',
  showPartnerLabel = false
}: ChampionLogoProps) {
  const isLight = variant === 'light';
  const partnerColor = isLight ? 'text-white/70' : 'text-gray-500';
  const sizeClasses = {
    sm: 'h-8 md:h-10',
    md: 'h-10 md:h-14',
    lg: 'h-14 md:h-18'
  };
  return <div className="flex flex-col" data-id="element-546">
      {showPartnerLabel && <span className={`text-[10px] font-bold uppercase tracking-wider mb-1 ${partnerColor}`} data-id="element-547">
          Partner
        </span>}
      <img src={LOGO_URL} alt="Champion Windows - Sunrooms - Home Exteriors" className={`${sizeClasses[size]} w-auto object-contain ${isLight ? '' : 'brightness-[0.85] contrast-[1.2]'}`} draggable={false} data-id="element-548" />
    </div>;
}